import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('USER_MANUAL')